import { ColGroupDef } from 'ag-grid-enterprise';
import { Enums} from 'Mri.Web.Common';
import { Enums_Config } from 'Mri.Web.Common/Utils/Enums_Config';
import * as React from 'react';
import { ActiveDisplay } from '../../ActiveDisplay';
import {IDisplayFieldProps} from "./DisplayFields";
import {AccountStore} from "../../../Account/AccountStore";


export function getDisplayConfigFields(accountStore: AccountStore): ColGroupDef<ActiveDisplay>[] {
    return [
        {
            headerName: 'Display',
            children: [
                {
                    field: 'configPoll?.displayConfig?.configRevision' as any,
                    headerName: "Config Revision",
                    cellRenderer: (props: IDisplayFieldProps) =>
                        <div>
                            {props.data?.configPoll?.displayConfig?.configRevision}
                        </div>,
                    valueGetter: (props) => props.data?.configPoll?.displayConfig?.configRevision,
                    initialHide: true,
                },
                {
                    headerName: 'Board Type',
                    initialHide: true,
                    field: 'configPoll?.displayConfig?.productName' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.displayConfig?.productName}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.displayConfig?.productName,
                },
                {
                    headerName: 'Start Up Command',
                    initialHide: true,
                    field: 'configPoll?.displayConfig?.startupCommand' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.displayConfig?.startupCommand}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.displayConfig?.startupCommand,
                },
                {
                    headerName: 'Display Variant',
                    initialHide: true,
                    field: 'configPoll?.displayConfig?.displayVariant' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.displayConfig?.displayVariant}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.displayConfig?.displayVariant,
                },
                {
                    headerName: 'Has Two Screens',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.hasTwoScreens' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.hasTwoScreens != null
                                ? props.data?.configPoll?.videoConfig?.hasTwoScreens
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.hasTwoScreens,
                },
                {
                    headerName: 'Screen 1 Size',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[0]?.screenSize' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig.length > 0 &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.screenSize}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[0]?.screenSize,
                },
                {
                    headerName: 'Screen 2 Size',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[1]?.screenSize' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig.length > 1 &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig[1]?.screenSize}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[1]?.screenSize,
                },
                {
                    headerName: 'Video Input Source Screen 1',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.videoInputSources[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.videoInputSources &&
                            props.data?.configPoll?.videoConfig?.videoInputSources.length > 0
                                ? Enums.toString(
                                    Enums_Config.VideoInputSourceType,
                                    props.data?.configPoll?.videoConfig?.videoInputSources[0]
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.videoInputSources?.[0],
                },
                {
                    headerName: 'Video Input Source Screen 2',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.videoInputSources[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.videoInputSources &&
                            props.data?.configPoll?.videoConfig?.videoInputSources.length > 1
                                ? Enums.toString(
                                    Enums_Config.VideoInputSourceType,
                                    props.data?.configPoll?.videoConfig?.videoInputSources[1]
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.videoInputSources?.[1],
                },
                {
                    headerName: 'Test Pattern',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.testPatternWhenNoVideoInput' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.testPatternWhenNoVideoInput != null
                                ? Enums.toString(
                                    Enums_Config.TestPatternType,
                                    props.data?.configPoll?.videoConfig?.testPatternWhenNoVideoInput
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.testPatternWhenNoVideoInput,
                },
                {
                    headerName: 'Has Audio',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.hasAudio' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.hasAudio != null
                                ? props.data?.configPoll?.videoConfig?.hasAudio
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.hasAudio,
                },
                {
                    headerName: 'Audio Input Source 1',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.audioInputSources[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.audioInputSources &&
                            props.data?.configPoll?.videoConfig?.audioInputSources.length > 0
                                ? Enums.toString(
                                    Enums_Config.AudioInputSourceType,
                                    props.data?.configPoll?.videoConfig?.audioInputSources[0]
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.audioInputSources?.[0],
                },
                {
                    headerName: 'Audio Input Source 2',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.audioInputSources[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.audioInputSources &&
                            props.data?.configPoll?.videoConfig?.audioInputSources.length > 1
                                ? Enums.toString(
                                    Enums_Config.AudioInputSourceType,
                                    props.data?.configPoll?.videoConfig?.audioInputSources[1]
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.audioInputSources?.[1],
                },
                {
                    headerName: 'Volume Setting',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.volume' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.volume}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.volume,
                },
                {
                    headerName: 'Has Humidity Sensor',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.hasHumiditySensor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.hasHumiditySensor != null
                                ? props.data?.configPoll?.coolVuConfig?.hasHumiditySensor
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.hasHumiditySensor,
                },
                {
                    headerName: 'Has Pressure Sensor',
                    initialHide: true,
                    field: 'configPoll?.miscConfig?.hasPressureSensor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.miscConfig?.hasPressureSensor != null
                                ? props.data?.configPoll?.miscConfig?.hasPressureSensor
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.miscConfig?.hasPressureSensor,
                },
                {
                    headerName: 'Has Gps',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.hasGps' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.hasGps != null
                                ? props.data?.configPoll?.geoVuConfig?.hasGps
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.hasGps,
                },
                {
                    headerName: 'Mems Sensor Type',
                    initialHide: true,
                    field: 'configPoll?.motionSensorConfig?.type' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.motionSensorConfig?.type != null
                                ? Enums.toString(Enums_Config.MemsSensorType, props.data?.configPoll?.motionSensorConfig?.type)
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.motionSensorConfig?.type,
                },
                {
                    headerName: 'Shock Sensitivity',
                    initialHide: true,
                    field: 'configPoll?.motionSensorConfig?.sensitivity' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.motionSensorConfig?.sensitivity}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.motionSensorConfig?.sensitivity,
                },
                {
                    headerName: 'ShockVu Enabled',
                    initialHide: true,
                    field: 'configPoll?.motionSensorConfig?.shockVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.motionSensorConfig?.shockVuEnabled ? "Yes" : "No"}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.motionSensorConfig?.shockVuEnabled,
                },
                {
                    headerName: 'ShockVu Timeout',
                    initialHide: true,
                    field: 'configPoll?.motionSensorConfig?.shockVuTimeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.motionSensorConfig?.shockVuTimeout + " Seconds"}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.motionSensorConfig?.shockVuTimeout,
                },
                {
                    headerName: 'Frame Capture Orientation Screen 1',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.frameCaptureOrientations[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.frameCaptureOrientations &&
                            props.data?.configPoll?.videoConfig?.frameCaptureOrientations.length > 0
                                ? Enums.toString(
                                    Enums_Config.FrameCaptureOrientationType,
                                    props.data?.configPoll?.videoConfig?.frameCaptureOrientations[0]
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.frameCaptureOrientations?.[0],
                },
                {
                    headerName: 'Frame Capture Orientation Screen 2',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.frameCaptureOrientations[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.frameCaptureOrientations &&
                            props.data?.configPoll?.videoConfig?.frameCaptureOrientations.length > 1
                                ? Enums.toString(
                                    Enums_Config.FrameCaptureOrientationType,
                                    props.data?.configPoll?.videoConfig?.frameCaptureOrientations[1]
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.frameCaptureOrientations?.[1],
                },
                {
                    headerName: 'Telemetry Job Period',
                    initialHide: true,
                    field: 'configPoll?.syncConfig?.telemetryJobPeriod' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.syncConfig?.telemetryJobPeriod != null
                                ? props.data?.configPoll?.syncConfig?.telemetryJobPeriod != 0
                                    ? props.data?.configPoll?.syncConfig?.telemetryJobPeriod + ' Seconds'
                                    : 'Default'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.syncConfig?.telemetryJobPeriod,
                },
                {
                    headerName: 'Unit Status Job Period',
                    initialHide: true,
                    field: 'configPoll?.syncConfig?.statusJobPeriod' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.syncConfig?.statusJobPeriod != null
                                ? props.data?.configPoll?.syncConfig?.statusJobPeriod == 0
                                    ? props.data?.configPoll?.syncConfig?.statusJobPeriod + ' Seconds'
                                    : 'Default'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.syncConfig?.statusJobPeriod,
                },
            ]
        },
        {
            headerName: 'Network',
            children: [
                {
                    headerName: 'Host Name',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.hostName' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.hostName || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.hostName,
                },
                {
                    headerName: 'DHCP State',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.enableDhcp' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.enableDhcp != null
                                ? props.data?.configPoll?.networkConfig?.enableDhcp
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.enableDhcp,
                },
                {
                    headerName: 'Eth0 IP',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.wiredIpAddr' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.wiredIpAddr || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.wiredIpAddr,
                },
                {
                    headerName: 'Eth0 Gateway IP',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.gatewayAddr' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.gatewayAddr || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.gatewayAddr,
                },
                {
                    headerName: 'Eth0 Net Mask',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.netMask' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.netMask || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.netMask,
                },
                {
                    headerName: 'DNS',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.dns' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.dns || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.dns,
                },
                {
                    headerName: 'NTP Server Address',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.ntpServerAddr' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.ntpServerAddr || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.ntpServerAddr,
                },
                {
                    headerName: 'Http Proxy',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.enableHttpProxy' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.enableHttpProxy != null
                                ? props.data?.configPoll?.networkConfig?.enableHttpProxy
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.enableHttpProxy,
                },
                {
                    headerName: 'Http Proxy URL',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.proxyUrl' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.proxyUrl || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.proxyUrl,
                },
                {
                    headerName: 'Time Zone',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.timezone' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.timezone || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.timezone,
                },
                {
                    headerName: 'Time Zone Update Period',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.timezoneCheckPeriod' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.timezoneCheckPeriod != null
                                ? props.data?.configPoll?.geoVuConfig?.timezoneCheckPeriod + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.timezoneCheckPeriod,
                },
                {
                    headerName: 'Web Page Password',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.webUserId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.webUserId || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.webUserId,
                },
                {
                    headerName: 'External IP Modem Monitoring',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.externalIp' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.externalIp || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.externalIp,
                },
                {
                    headerName: 'Weather Service URL',
                    initialHide: true,
                    field: 'configPoll?.weatherVuConfig?.weatherUrl' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.weatherVuConfig?.weatherUrl || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.weatherVuConfig?.weatherUrl,
                },
                {
                    headerName: 'Secondary/Maintenance IP',
                    initialHide: true,
                    field: 'configPoll?.networkConfig?.secondaryDebugIp' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.networkConfig?.secondaryDebugIp || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.networkConfig?.secondaryDebugIp,
                },
            ]
        },
        {
            headerName: 'AC & Battery',
            children: [
                {
                    headerName: 'Power Supply Capacity',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.psPowerCapacity' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.psPowerCapacity
                                ? props.data?.configPoll?.ampVuConfig?.psPowerCapacity != 0
                                    ? '1000W'
                                    : '500W'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.psPowerCapacity,
                },
                {
                    headerName: 'Number of Power Supplies',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.numInstalledPowerSupplies' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.numInstalledPowerSupplies || '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.numInstalledPowerSupplies,
                },
                {
                    headerName: 'AC 120V Min Voltage',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[0]?.minVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                            props.data?.configPoll?.ampVuConfig?.ranges.length > 0 ?
                                props.data?.configPoll?.ampVuConfig?.ranges[0]?.minVoltage : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[0]?.minVoltage,
                },
                {
                    headerName: 'AC 120V Max Voltage',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[0]?.maxVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                            props.data?.configPoll?.ampVuConfig?.ranges.length > 0 ?
                                props.data?.configPoll?.ampVuConfig?.ranges[0]?.maxVoltage : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[0]?.maxVoltage,
                },
                {
                    headerName: 'AC 120V Max Current',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[0]?.maxCurrent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                            props.data?.configPoll?.ampVuConfig?.ranges.length > 0 ?
                                props.data?.configPoll?.ampVuConfig?.ranges[0]?.maxCurrent : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[0]?.maxCurrent,
                },
                {
                    headerName: 'AC 208V Min Voltage',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[1]?.minVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                            props.data?.configPoll?.ampVuConfig?.ranges.length > 1 ?
                                props.data?.configPoll?.ampVuConfig?.ranges[1]?.minVoltage : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[1]?.minVoltage,
                },
                {
                    headerName: 'AC 208V Max Voltage',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[1]?.maxVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                            props.data?.configPoll?.ampVuConfig?.ranges.length > 1 ?
                                props.data?.configPoll?.ampVuConfig?.ranges[1]?.maxVoltage : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[1]?.maxVoltage,
                },
                {
                    headerName: 'AC 208V Max Current',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[1]?.maxCurrent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                                props.data?.configPoll?.ampVuConfig?.ranges.length > 1 &&
                                props.data?.configPoll?.ampVuConfig?.ranges[1]?.maxCurrent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[1]?.maxCurrent,
                },
                {
                    headerName: 'AC 240V Min Voltage',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[2]?.minVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                                props.data?.configPoll?.ampVuConfig?.ranges.length > 2 &&
                                props.data?.configPoll?.ampVuConfig?.ranges[2]?.minVoltage}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[2]?.minVoltage,
                },
                {
                    headerName: 'AC 240V Max Voltage',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[2]?.maxVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                                props.data?.configPoll?.ampVuConfig?.ranges.length > 2 &&
                                props.data?.configPoll?.ampVuConfig?.ranges[2]?.maxVoltage}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[2]?.maxVoltage,
                },
                {
                    headerName: 'AC 240V Max Current',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ranges[2]?.maxCurrent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ranges &&
                                props.data?.configPoll?.ampVuConfig?.ranges.length > 2 &&
                                props.data?.configPoll?.ampVuConfig?.ranges[2]?.maxCurrent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ranges?.[2]?.maxCurrent,
                },
                {
                    headerName: 'Has Surge Suppressor',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.hasSurgeSupressor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.hasSurgeSupressor != null
                                ? props.data?.configPoll?.ampVuConfig?.hasSurgeSupressor
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.hasSurgeSupressor,
                },
                {
                    headerName: 'High Power Supply Voltage Trigger',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.maxPSVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.maxPSVoltage}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.maxPSVoltage,
                },
                {
                    headerName: '48V Current Sharing Monitor Enabled',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.currentSharingMonitorEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.currentSharingMonitorEnabled != null
                                ? props.data?.configPoll?.ampVuConfig?.currentSharingMonitorEnabled
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.currentSharingMonitorEnabled,
                },
                {
                    headerName: '48V Power Supply Current Disparity',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.maxCurrentSharingDisparity' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.maxCurrentSharingDisparity}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.maxCurrentSharingDisparity,
                },
                {
                    headerName: '12V Current Monitoring Enabled',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.currentMonitoring12VEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.currentMonitoring12VEnabled != null
                                ? props.data?.configPoll?.ampVuConfig?.currentMonitoring12VEnabled
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.currentMonitoring12VEnabled,
                },
                {
                    headerName: '12V Power Supply Current Disparity',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.max12VCurrentSharingDisparity' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.max12VCurrentSharingDisparity}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.max12VCurrentSharingDisparity,
                },
                {
                    headerName: 'Voltage Threshold Failure Incident',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.twelveVoltSupplyVoltageThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.twelveVoltSupplyVoltageThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.twelveVoltSupplyVoltageThreshold,
                },
                {
                    headerName: 'Current Threshold Failure Incident',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.twelveVoltSupplyCurrentThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.twelveVoltSupplyCurrentThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.twelveVoltSupplyCurrentThreshold,
                },
            ]
        },
        {
            headerName: 'Backlight',
            children: [
                {
                    headerName: 'Use DAC Adjustment',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.useDac' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.useDac != null
                                ? props.data?.configPoll?.brightVuConfig?.useDac
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.useDac,
                },
                {
                    headerName: 'Backlight 1 Luminance Control Mode',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[0]?.luminanceMode' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                            props.data?.configPoll?.brightVuConfig?.panelConfig.length > 0 &&
                            props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.luminanceMode != null
                                ? Enums.toString(
                                    Enums_Config.LuminanceModeType,
                                    props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.luminanceMode
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[0]?.luminanceMode,
                },
                {
                    headerName: 'Backlight 1 Desired Luminance Nits',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[0]?.fixedNits' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig.length > 0 &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.fixedNits}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[0]?.fixedNits,
                },
                {
                    headerName: 'Backlight 1 Desired Daytime Luminance Nits',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[0]?.daytimeNits' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig.length > 0 &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.daytimeNits}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[0]?.daytimeNits,
                },
                {
                    headerName: 'Backlight 1 Desired Nighttime Luminance Nits',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[0]?.nighttimeNits' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig.length > 0 &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.nighttimeNits}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[0]?.nighttimeNits,
                },
                {
                    headerName: 'Backlight 1 Minimum Daytime Nits',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.panelConfig[0]?.minDaytimeNits' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.panelConfig &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig.length > 0 &&
                                props.data?.configPoll?.brightVuConfig?.panelConfig[0]?.minDaytimeNits}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.panelConfig?.[0]?.minDaytimeNits,
                },
                {
                    headerName: 'Light Sensor Type',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.ambientLightSensor?.type' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.ambientLightSensor?.type != null
                                ? Enums.toString(
                                    Enums_Config.AmbientLightSensorType,
                                    props.data?.configPoll?.geoVuConfig?.ambientLightSensor?.type
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.ambientLightSensor?.type,
                },
            ]
        },
        {
            headerName: 'Door Sensors',
            children: [
                {
                    headerName: 'Primary Proximity',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryProximity
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryProximity
                        ) : '-',
                },
                {
                    headerName: 'Primary Proximity Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryProximity
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryProximity
                        ) : '-',
                },
                {
                    headerName: 'Primary Latches',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryLatches
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryLatches
                        ) : '-',
                },
                {
                    headerName: 'Primary Latches Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryLatches
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryLatches
                        ) : '-',
                },
                {
                    headerName: 'Primary Left Latch',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryLeftLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryLeftLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Primary Left Latch Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryLeftLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryLeftLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Primary Right Latch',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryRightLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryRightLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Primary Right Latch Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.PrimaryRightLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.PrimaryRightLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Future 4',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future4
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future4
                        )
                        : '-',
                },
                {
                    headerName: 'Future 4 Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future4
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future4
                        )
                        : '-',
                },
                {
                    headerName: 'Future 5',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future5
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future5
                        )
                        : '-',
                },
                {
                    headerName: 'Future 5 Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future5
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future5
                        )
                        : '-',
                },
                {
                    headerName: 'Future 6',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future6
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future6
                        )
                        : '-',
                },
                {
                    headerName: 'Future 6 Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future6
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future6
                        )
                        : '-',
                },
                {
                    headerName: 'Future 7',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future7
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future7
                        )
                        : '-',
                },
                {
                    headerName: 'Future 7 Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future7
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future7
                        )
                        : '-',
                },
                {
                    headerName: 'Future 8',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future8
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future8
                        )
                        : '-',
                },
                {
                    headerName: 'Future 8 Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future8
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future8
                        )
                        : '-',
                },
                {
                    headerName: 'Future 9',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future9
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future9
                        )
                        : '-',
                },
                {
                    headerName: 'Future 9 Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.Future9
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.Future9
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Proximity',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryProximity
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryProximity
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Proximity Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryProximity
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryProximity
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Latches',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryLatches
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryLatches
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Latches Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryLatches
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryLatches
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Left Latch',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryLeftLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryLeftLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Left Latch Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryLeftLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryLeftLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Right Latch',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorConnector(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryRightLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorConnector(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryRightLatch
                        )
                        : '-',
                },
                {
                    headerName: 'Secondary Right Latch Enabled',
                    initialHide: true,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorSensorsConfig?.sensors ?
                                getDoorSensorEnabled(
                                    props.data?.configPoll?.doorSensorsConfig?.sensors,
                                    Mri.Config.DoorSensorType.SecondaryRightLatch
                                ) : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorSensorsConfig?.sensors
                        ? getDoorSensorEnabled(
                            props.data?.configPoll?.doorSensorsConfig?.sensors,
                            Mri.Config.DoorSensorType.SecondaryRightLatch
                        )
                        : '-',
                },
            ]
        },
        {
            headerName: 'GeoVu',
            children: [
                {
                    headerName: 'City Location',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.locationName' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.locationName}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.locationName,
                },

                {
                    headerName: 'Sunrise Start Time Offset',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.sunriseStartOffset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.sunriseStartOffset != null
                                ? props.data?.configPoll?.geoVuConfig?.sunriseStartOffset + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.sunriseStartOffset,
                },
                {
                    headerName: 'Sunrise End Time Offset',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.sunriseEndOffset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.sunriseEndOffset != null
                                ? props.data?.configPoll?.geoVuConfig?.sunriseEndOffset + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.sunriseEndOffset,
                },
                {
                    headerName: 'Sunset Start Time Offset',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.sunsetStartOffset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.sunsetStartOffset != null
                                ? props.data?.configPoll?.geoVuConfig?.sunsetStartOffset + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.sunsetStartOffset,
                },
                {
                    headerName: 'Sunset End Time Offset',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.sunsetEndOffset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.sunsetEndOffset != null
                                ? props.data?.configPoll?.geoVuConfig?.sunsetEndOffset + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.sunsetEndOffset,
                },
                {
                    headerName: 'Weather Check Interval',
                    initialHide: true,
                    field: 'configPoll?.weatherVuConfig?.weatherCheckIntervalSec' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.weatherVuConfig?.weatherCheckIntervalSec != null
                                ? props.data?.configPoll?.weatherVuConfig?.weatherCheckIntervalSec + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.weatherVuConfig?.weatherCheckIntervalSec,
                },
            ]
        },
        {
            headerName: 'Temperature Control',
            children: [
                {
                    headerName: 'Ambient Delta Alert Timeout',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.ambientDeltaAlertTimeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.ambientDeltaAlertTimeout != null
                                ? props.data?.configPoll?.coolVuConfig?.ambientDeltaAlertTimeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.ambientDeltaAlertTimeout,
                },
                {
                    headerName: 'Ambient Delta Warning Threshold',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.ambientDeltaThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.ambientDeltaThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.ambientDeltaThreshold,
                },
                {
                    headerName: 'Over Temp Threshold Above Max',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.overtempThresholdAboveMax' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.overtempThresholdAboveMax}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.overtempThresholdAboveMax,
                },
                {
                    headerName: 'Shutdown Temp Threshold Above Max',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.shutdownThresholdAboveMax' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.shutdownThresholdAboveMax}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.shutdownThresholdAboveMax,
                },

                {
                    headerName: 'InfiniteTouch Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.infiniteTouchOffset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.infiniteTouchOffset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.infiniteTouchOffset,
                },
                {
                    headerName: 'Zone 1 Power Supply Temps Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[0]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[0]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[0]?.offset,
                },
                {
                    headerName: 'Zone 1 240 Board Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[1]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[1]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[1]?.offset,
                },
                {
                    headerName: 'Zone 1 Backlight Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[2]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 2
                                ? props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[2]?.offset
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[2]?.offset,
                },
                {
                    headerName: 'Zone 1 Ambient Inlet Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[3]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 3 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[3]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[3]?.offset,
                },
                {
                    headerName: 'Zone 1 Closed Loop Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[4]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 4 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[4]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[4]?.offset,
                },
                {
                    headerName: 'Zone 1 FPGA Die Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[5]?.offset',
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 5 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[5]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[5]?.offset,
                },
                {
                    headerName: 'Zone 1 Humidity Sensor Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[6]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 6 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[6]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[6]?.offset,
                },
                {
                    headerName: 'Zone 1 Pressure Sensor Temp Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.sources[7]?.offset' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0].sources &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources.length > 7 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.sources[7]?.offset}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.sources?.[7]?.offset,
                },
                {
                    headerName: 'Zone 1 Min Adjust Temp',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.minTempThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.minTempThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.minTempThreshold,
                },
                {
                    headerName: 'Zone 1 Max Adjust Temp',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.maxTempThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.maxTempThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.maxTempThreshold,
                },
                {
                    headerName: 'Zone 1 Num Fan Banks',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.numFanBanks' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.numFanBanks}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.numFanBanks,
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan Bank Type',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.type' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.type != null
                                ? Enums.toString(
                                    Enums_Config.FanBankType,
                                    props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.type
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.type,
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan Minimum On Speed',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.fanOnThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.fanOnThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.fanOnThreshold,
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan Bank IsLocal',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.isLocal' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.isLocal != null
                                ? props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.isLocal
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.isLocal,
                },
                {
                    headerName: 'Zone 1 Bank 1 Num Steps Before Change',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.numLoopsBeforeStep' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.numLoopsBeforeStep}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.numLoopsBeforeStep,
                },
                {
                    headerName: 'Zone 1 Bank 1 Min Fan',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.minTempPercent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.minTempPercent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.minTempPercent,
                },
                {
                    headerName: 'Zone 1 Bank 1 Max Fan',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.maxTempPercent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.maxTempPercent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.maxTempPercent,
                },
                {
                    headerName: 'Zone 1 Bank 1 Night Mode',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.supportNightMode' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.supportNightMode != null
                                ? props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.supportNightMode
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.supportNightMode,
                },
                {
                    headerName: 'Zone 1 Bank 1 Night Time Min Fan',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.nightModeMin' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.nightModeMin}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.nightModeMin,
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan Speed Step Size',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.stepPercent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.stepPercent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.stepPercent,
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan Nominal Voltage',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.nominalVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.nominalVoltage}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.nominalVoltage,
                },
                {
                    headerName: 'Zone 1 Bank 1 Num Fans',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.numFans' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.numFans}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.numFans,
                },
                {
                    headerName: 'Zone 1 Bank 1 Pwm 1',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[0]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.pwmIds?.[0],
                },
                {
                    headerName: 'Zone 1 Bank 1 Pwm 2',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[1]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.pwmIds?.[1],
                },
                {
                    headerName: 'Zone 1 Bank 1 Pwm 3',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[2]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds.length > 2 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[2]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.pwmIds?.[2],
                },
                {
                    headerName: 'Zone 1 Bank 1 Pwm 4',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[3]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds.length > 3 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.pwmIds[3]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.pwmIds?.[3],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 5',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[0]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[0],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 2',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[1]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[1],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 3',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[2]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 2 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[2]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[2],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 4',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[3]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 3 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[3]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[3],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 5',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[4]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 4 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[4]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[4],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 6',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[5]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 5 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[5]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[5],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 7',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[6]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 6 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[6]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[6],
                },
                {
                    headerName: 'Zone 1 Bank 1 Fan 8',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[7]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds.length > 7 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[0]?.connectorIds[7]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[0]?.connectorIds?.[7],
                },

                {
                    headerName: 'Zone 1 Bank 2 Fan Bank Type',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.type' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.type != null
                                ? Enums.toString(
                                    Enums_Config.FanBankType,
                                    props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.type
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.type,
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan Minimum On Speed',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.fanOnThreshold' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.fanOnThreshold}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.fanOnThreshold,
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan Bank IsLocal',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.isLocal' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.isLocal != null
                                ? props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.isLocal
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.isLocal,
                },
                {
                    headerName: 'Zone 1 Bank 2 Num Steps Before Change:',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.numLoopsBeforeStep' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.numLoopsBeforeStep}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.numLoopsBeforeStep,
                },
                {
                    headerName: 'Zone 1 Bank 2 Min Fan',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.minTempPercent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.minTempPercent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.minTempPercent,
                },
                {
                    headerName: 'Zone 1 Bank 2 Max Fan',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.maxTempPercent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.maxTempPercent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.maxTempPercent,
                },
                {
                    headerName: 'Zone 1 Bank 2 Night Mode',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.supportNightMode' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                            props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                            props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.supportNightMode != null
                                ? props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.supportNightMode
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.supportNightMode,
                },
                {
                    headerName: 'Zone 1 Bank 2 Night Time Min Fan',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.nightModeMin' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.nightModeMin}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.nightModeMin,
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan Speed Step Size',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.stepPercent' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.stepPercent}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.stepPercent,
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan Nominal Voltage',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.nominalVoltage' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.nominalVoltage}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.nominalVoltage,
                },
                {
                    headerName: 'Zone 1 Bank 2 Num Fans',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.numFans' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.numFans}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.numFans,
                },
                {
                    headerName: 'Zone 1 Bank 2 Pwm 1',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[0]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.pwmIds?.[0],
                },
                {
                    headerName: 'Zone 1 Bank 2 Pwm 2',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[1]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.pwmIds?.[1],
                },
                {
                    headerName: 'Zone 1 Bank 2 Pwm 3',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[2]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds.length > 2 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[2]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.pwmIds?.[2],
                },
                {
                    headerName: 'Zone 1 Bank 2 Pwm 4',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[3]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds.length > 3 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.pwmIds[3]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.pwmIds?.[3],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 1',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[0]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[0],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 2',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[1]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[1],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 3',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[2]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 2 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[2]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[2],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 4',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[3]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 3 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[3]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[3],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 5',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[4]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 4 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[4]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[4],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 6',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[5]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 5 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[5]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[5],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 7',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[6]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 6 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[6]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[6],
                },
                {
                    headerName: 'Zone 1 Bank 2 Fan 8',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[7]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.zones &&
                                props.data?.configPoll?.coolVuConfig?.zones.length > 0 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks.length > 1 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds.length > 7 &&
                                props.data?.configPoll?.coolVuConfig?.zones[0]?.fanBanks[1]?.connectorIds[7]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.zones?.[0]?.fanBanks?.[1]?.connectorIds?.[7],
                },
            ]
        },
        {
            headerName: 'Humidity Config',
            children: [
                {
                    headerName: 'Dewpoint Calculation Temp Source',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.dewPointTempSource' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.dewPointTempSource != null
                                ? Enums.toString(
                                    Enums_Config.DewpointCalculationTempSource,
                                    props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.dewPointTempSource
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.dewPointTempSource,
                },
                {
                    headerName: 'Closed Loop Night Min',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.closedLoopNightDewpointMin' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.closedLoopNightDewpointMin}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.closedLoopNightDewpointMin,
                },
                {
                    headerName: 'Inlet DPS Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.clTempSafety' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.clTempSafety}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.clTempSafety,
                },
                {
                    headerName: 'Closed Loop DPS Offset',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.blMaxTempSafety' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.blMaxTempSafety}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.blMaxTempSafety,
                },
                {
                    headerName: 'Offset Switching Hysteresis',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.psMaxTempSafety' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.psMaxTempSafety}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.psMaxTempSafety,
                },
                {
                    headerName: 'Dewpoint Spread Set Buffer',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.setBuffer' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.setBuffer}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.setBuffer,
                },
                {
                    headerName: 'Dewpoint Spread Clear Buffer',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.clearBuffer' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.clearBuffer}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.clearBuffer,
                },
                {
                    headerName: 'Offset Switch Delay',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.offsetSwitchDelay' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.offsetSwitchDelay}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.offsetSwitchDelay,
                },
                {
                    headerName: 'Dps Minimum',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.humidityZoneConfig?.dpsMinimum' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.dpsMinimum}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.humidityZoneConfig?.dpsMinimum,
                },
            ]
        },
        {
            headerName: 'Controller',
            children: [
                {
                    headerName: 'Door Monitor Control Type',
                    initialHide: true,
                    field: 'configPoll?.doorWatchdogConfig?.controlType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorWatchdogConfig?.controlType != null
                                ? Enums.toString(
                                    Enums_Config.DoorWatchdogControlType,
                                    props.data?.configPoll?.doorWatchdogConfig?.controlType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorWatchdogConfig?.controlType,
                },
                {
                    headerName: 'Watchdog Timer',
                    initialHide: true,
                    field: 'configPoll?.displayConfig?.enableWatchdog' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.displayConfig?.enableWatchdog != null
                                ? props.data?.configPoll?.displayConfig?.enableWatchdog
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.displayConfig?.enableWatchdog,
                },
                {
                    headerName: 'Enable Api Watchdog',
                    initialHide: true,
                    field: 'configPoll?.displayConfig?.enableApiWatchdog' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.displayConfig?.enableApiWatchdog != null
                                ? props.data?.configPoll?.displayConfig?.enableApiWatchdog
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.displayConfig?.enableApiWatchdog,
                },

                {
                    headerName: 'Mezzanine Control',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.enabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.enabled != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.enabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.enabled,
                },
                {
                    headerName: 'Track Controller',
                    initialHide: true,
                    field: 'configPoll?.miscConfig?.trackControllerEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.miscConfig?.trackControllerEnabled != null
                                ? props.data?.configPoll?.miscConfig?.trackControllerEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.miscConfig?.trackControllerEnabled,
                },
                {
                    headerName: 'Fan Controller',
                    initialHide: true,
                    field: 'configPoll?.coolVuConfig?.coolVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.coolVuConfig?.coolVuEnabled != null
                                ? props.data?.configPoll?.coolVuConfig?.coolVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.coolVuConfig?.coolVuEnabled,
                },
                {
                    headerName: 'AmpVu Controller',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.ampVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.ampVuEnabled != null
                                ? props.data?.configPoll?.ampVuConfig?.ampVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.ampVuEnabled,
                },
                {
                    headerName: 'ETR Controller',
                    initialHide: true,
                    field: 'configPoll?.videoCoreWatchdogConfig?.etrEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoCoreWatchdogConfig?.etrEnabled != null
                                ? props.data?.configPoll?.videoCoreWatchdogConfig?.etrEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoCoreWatchdogConfig?.etrEnabled,
                },
                {
                    headerName: 'BIT Processing',
                    initialHide: true,
                    field: 'configPoll?.testVuConfig?.bitEnabled',
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.testVuConfig?.bitEnabled != null
                                ? props.data?.configPoll?.testVuConfig?.bitEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.testVuConfig?.bitEnabled,
                },
                {
                    headerName: 'Door Monitor Controller',
                    initialHide: true,
                    field: 'configPoll?.doorWatchdogConfig?.enable' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.doorWatchdogConfig?.enable != null
                                ? props.data?.configPoll?.doorWatchdogConfig?.enable
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.doorWatchdogConfig?.enable,
                },
                {
                    headerName: 'Backlight Controller',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.brightVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.brightVuEnabled != null
                                ? props.data?.configPoll?.brightVuConfig?.brightVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.brightVuEnabled,
                },
                {
                    headerName: 'TCON SPI Controller',
                    initialHide: true,
                    field: 'configPoll?.miscConfig?.readTconSpiEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.miscConfig?.readTconSpiEnabled != null
                                ? props.data?.configPoll?.miscConfig?.readTconSpiEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.miscConfig?.readTconSpiEnabled,
                },
                {
                    headerName: 'Master Comm Controller',
                    initialHide: true,
                    field: 'configPoll?.miscConfig?.masterCommEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.miscConfig?.masterCommEnabled != null
                                ? props.data?.configPoll?.miscConfig?.masterCommEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.miscConfig?.masterCommEnabled,
                },
                {
                    headerName: 'OSD Controller',
                    initialHide: true,
                    field: 'configPoll?.osdConfig?.enabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.osdConfig?.enabled != null
                                ? props.data?.configPoll?.osdConfig?.enabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.osdConfig?.enabled,
                },
                {
                    headerName: 'Sunrise/Sunset Controller',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.geoVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.geoVuEnabled != null
                                ? props.data?.configPoll?.geoVuConfig?.geoVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.geoVuEnabled,
                },
                {
                    headerName: 'Weather Controller',
                    initialHide: true,
                    field: 'configPoll?.weatherVuConfig?.weatherVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.weatherVuConfig?.weatherVuEnabled != null
                                ? props.data?.configPoll?.weatherVuConfig?.weatherVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.weatherVuConfig?.weatherVuEnabled,
                },
                {
                    headerName: 'Timezone Controller',
                    initialHide: true,
                    field: 'configPoll?.geoVuConfig?.timezoneControllerEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.geoVuConfig?.timezoneControllerEnabled != null
                                ? props.data?.configPoll?.geoVuConfig?.timezoneControllerEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.geoVuConfig?.timezoneControllerEnabled,
                },
                {
                    headerName: 'License Controller',
                    initialHide: true,
                    field: 'configPoll?.licenseVuConfig?.enabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.licenseVuConfig?.enabled != null
                                ? props.data?.configPoll?.licenseVuConfig?.enabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.licenseVuConfig?.enabled,
                },
                {
                    headerName: 'Auto Standby Controller',
                    initialHide: true,
                    field: 'configPoll?.brightVuConfig?.autoStandbyConfig[0]?.enabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.brightVuConfig?.autoStandbyConfig[0]?.enabled != null
                                ? props.data?.configPoll?.brightVuConfig?.autoStandbyConfig[0]?.enabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.brightVuConfig?.autoStandbyConfig?.[0]?.enabled,
                },
                {
                    headerName: 'Cron Controller',
                    initialHide: true,
                    field: 'configPoll?.cronConfig?.cronEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.cronConfig?.cronEnabled != null
                                ? props.data?.configPoll?.cronConfig?.cronEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.cronConfig?.cronEnabled,
                },
                {
                    headerName: 'Sync Controller',
                    initialHide: true,
                    field: 'configPoll?.syncConfig?.syncEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.syncConfig?.syncEnabled != null
                                ? props.data?.configPoll?.syncConfig?.syncEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.syncConfig?.syncEnabled,
                },
                {
                    headerName: 'WattVu Controller',
                    initialHide: true,
                    field: 'configPoll?.wattVuConfig?.wattVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.wattVuConfig?.wattVuEnabled != null
                                ? props.data?.configPoll?.wattVuConfig?.wattVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.wattVuConfig?.wattVuEnabled,
                },
                {
                    headerName: 'InfiniteTouch Controller',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.sigmaSenseEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.sigmaSenseEnabled != null
                                ? props.data?.configPoll?.sigmaSenseConfig?.sigmaSenseEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.sigmaSenseEnabled,
                },
                {
                    headerName: 'PopVu Controller',
                    initialHide: true,
                    field: 'configPoll?.popVuConfig?.popVuEnabled' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.popVuConfig?.popVuEnabled != null
                                ? props.data?.configPoll?.popVuConfig?.popVuEnabled
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.popVuConfig?.popVuEnabled,
                },
                {
                    headerName: 'Vtrim Monitor',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorEnable' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorEnable != null
                                ? props.data?.configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorEnable
                                    ? 'Enabled'
                                    : 'Disabled'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorEnable,
                },
            ]
        },
        {
            headerName: 'Gamma',
            children: [
                {
                    headerName: 'Auto Gamma Table Selection',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.dynamicTableSelect' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.dynamicTableSelect != null
                                ? props.data?.configPoll?.gammaConfig?.dynamicTableSelect
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.dynamicTableSelect,
                },
                {
                    headerName: 'Gamma Variant Screen 1',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.gammaVariant[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.gammaVariant == null ||
                            props.data?.configPoll?.gammaConfig?.gammaVariant.length <= 0
                                ? 'N/A'
                                : Enums.toString(Enums_Config.GammaVariantType, props.data?.configPoll?.gammaConfig?.gammaVariant[0])}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.gammaVariant?.[0],
                },
                {
                    headerName: 'Gamma Variant Screen 2',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.gammaVariant[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.gammaVariant == null ||
                            props.data?.configPoll?.gammaConfig?.gammaVariant.length <= 1
                                ? 'N/A'
                                : Enums.toString(Enums_Config.GammaVariantType, props.data?.configPoll?.gammaConfig?.gammaVariant[1])}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.gammaVariant?.[1],
                },
                {
                    headerName: 'Gamma Table Number Screen 1',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.gammaTableNum[0]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.gammaTableNum == null ||
                            props.data?.configPoll?.gammaConfig?.gammaTableNum.length <= 0
                                ? 'N/A'
                                : props.data?.configPoll?.gammaConfig?.gammaTableNum[0]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.gammaTableNum?.[0],
                },
                {
                    headerName: 'Gamma Table Number Screen 2',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.gammaTableNum[1]' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.gammaTableNum == null ||
                            props.data?.configPoll?.gammaConfig?.gammaTableNum.length <= 1
                                ? 'N/A'
                                : props.data?.configPoll?.gammaConfig?.gammaTableNum[1]}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.gammaTableNum?.[1],
                },
                {
                    headerName: 'Normalized High Ambient',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.normalizedHighAmbient' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.normalizedHighAmbient}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.normalizedHighAmbient,
                },
                {
                    headerName: 'Max Red Component',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.maxComponentValues.maxRed' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.maxComponentValues?.maxRed}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.maxComponentValues?.maxRed,
                },
                {
                    headerName: 'Max Green Component',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.maxComponentValues.maxGreen' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.maxComponentValues?.maxGreen}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.maxComponentValues?.maxGreen,
                },
                {
                    headerName: 'Max Blue Component',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.maxComponentValues.maxBlue' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.maxComponentValues?.maxBlue}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.maxComponentValues?.maxBlue,
                },
                {
                    headerName: 'Gamma Table 0 Ambient',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[0]?.maxAmbientReading' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 0 &&
                                props.data?.configPoll?.gammaConfig?.tables[0]?.maxAmbientReading}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[0]?.maxAmbientReading,
                },
                {
                    headerName: 'Gamma Table 0 Floor',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[0]?.floor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 0 &&
                                props.data?.configPoll?.gammaConfig?.tables[0]?.floor}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[0]?.floor,
                },
                {
                    headerName: 'Gamma Table 0 Max Black Pixel',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[0]?.maxBlackPixelValue' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 0 &&
                                props.data?.configPoll?.gammaConfig?.tables[0]?.maxBlackPixelValue}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[0]?.maxBlackPixelValue,
                },
                {
                    headerName: 'Gamma Table 0 Gamma',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[0]?.gamma' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 0 &&
                                props.data?.configPoll?.gammaConfig?.tables[0]?.gamma}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[0]?.gamma,
                },
                {
                    headerName: 'Gamma Table 1 Ambient',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[1]?.maxAmbientReading' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 1 &&
                                props.data?.configPoll?.gammaConfig?.tables[1]?.maxAmbientReading}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[1]?.maxAmbientReading,
                },
                {
                    headerName: 'Gamma Table 1 Floor',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[1]?.floor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 1 &&
                                props.data?.configPoll?.gammaConfig?.tables[1]?.floor}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[1]?.floor,
                },
                {
                    headerName: 'Gamma Table 1 Max Black Pixel',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[1]?.maxBlackPixelValue' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 1 &&
                                props.data?.configPoll?.gammaConfig?.tables[1]?.maxBlackPixelValue}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[1]?.maxBlackPixelValue,
                },
                {
                    headerName: 'Gamma Table 1 Gamma',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[1]?.gamma' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 1 &&
                                props.data?.configPoll?.gammaConfig?.tables[1]?.gamma}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[1]?.gamma,
                },
                {
                    headerName: 'Gamma Table 2 Ambient',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[2]?.maxAmbientReading' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 2 &&
                                props.data?.configPoll?.gammaConfig?.tables[2]?.maxAmbientReading}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[2]?.maxAmbientReading,
                },
                {
                    headerName: 'Gamma Table 2 Floor',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[2]?.floor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 2 &&
                                props.data?.configPoll?.gammaConfig?.tables[2]?.floor}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[2]?.floor,
                },
                {
                    headerName: 'Gamma Table 2 Max Black Pixel',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[2]?.maxBlackPixelValue' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 2 &&
                                props.data?.configPoll?.gammaConfig?.tables[2]?.maxBlackPixelValue}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[2]?.maxBlackPixelValue,
                },
                {
                    headerName: 'Gamma Table 2 Gamma',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[2]?.gamma' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 2 &&
                                props.data?.configPoll?.gammaConfig?.tables[2]?.gamma}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[2]?.gamma,
                },
                {
                    headerName: 'Gamma Table 3 Ambient',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[3]?.maxAmbientReading' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 3 &&
                                props.data?.configPoll?.gammaConfig?.tables[3]?.maxAmbientReading}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[3]?.maxAmbientReading,
                },
                {
                    headerName: 'Gamma Table 3 Floor',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[3]?.floor' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 3 &&
                                props.data?.configPoll?.gammaConfig?.tables[3]?.floor}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[3]?.floor,
                },
                {
                    headerName: 'Gamma Table 3 Max Black Pixel',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[3]?.maxBlackPixelValue' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 3 &&
                                props.data?.configPoll?.gammaConfig?.tables[3]?.maxBlackPixelValue}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[3]?.maxBlackPixelValue,
                },
                {
                    headerName: 'Gamma Table 3 Gamma',
                    initialHide: true,
                    field: 'configPoll?.gammaConfig?.tables[3]?.gamma' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.gammaConfig?.tables &&
                                props.data?.configPoll?.gammaConfig?.tables.length > 3 &&
                                props.data?.configPoll?.gammaConfig?.tables[3]?.gamma}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.gammaConfig?.tables?.[3]?.gamma,
                },
            ]
        },
        {
            headerName: 'Aux Devices',
            children: [
                {
                    headerName: 'Reboot Player Stalled Video',
                    initialHide: true,
                    field: 'configPoll?.videoCoreWatchdogConfig?.rebootPlayerForStalledVideoType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoCoreWatchdogConfig?.rebootPlayerForStalledVideoType != null
                                ? Enums.toString(
                                    Enums_Config.RebootPlayerOnStalledVideoType,
                                    props.data?.configPoll?.videoCoreWatchdogConfig?.rebootPlayerForStalledVideoType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoCoreWatchdogConfig?.rebootPlayerForStalledVideoType,
                },
                {
                    headerName: 'Video Stall Reboot Wait Time',
                    initialHide: true,
                    field: 'configPoll?.videoCoreWatchdogConfig?.rebootWaitTimeForStalledVideo' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoCoreWatchdogConfig?.rebootWaitTimeForStalledVideo}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoCoreWatchdogConfig?.rebootWaitTimeForStalledVideo,
                },
                {
                    headerName: 'Reboot Player Invalid Video Input',
                    initialHide: true,
                    field: 'configPoll?.videoCoreWatchdogConfig?.rebootPlayerForInvalidVideoInput' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoCoreWatchdogConfig?.rebootPlayerForInvalidVideoInput != null
                                ? props.data?.configPoll?.videoCoreWatchdogConfig?.rebootPlayerForInvalidVideoInput
                                    ? 'True'
                                    : 'False'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoCoreWatchdogConfig?.rebootPlayerForInvalidVideoInput,
                },
                {
                    headerName: 'Invalid Video Input Reboot Wait Time',
                    initialHide: true,
                    field: 'configPoll?.videoCoreWatchdogConfig?.rebootWaitTimeForInvalidVideoInput' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoCoreWatchdogConfig?.rebootWaitTimeForInvalidVideoInput}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoCoreWatchdogConfig?.rebootWaitTimeForInvalidVideoInput,
                },

                // DEVICE 0
                {
                    headerName: 'Device 0 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[0]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 0 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[0]?.deviceId,
                },
                {
                    headerName: 'Device 0 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[0]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 0 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[0]?.monitorType,
                },
                {
                    headerName: 'Device 0 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[0]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 0 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[0]?.timeout,
                },
                {
                    headerName: 'Device 0 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[0]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 0 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[0]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[0]?.connector,
                },

                // DEVICE 1
                {
                    headerName: 'Device 1 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[1]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 1 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[1]?.deviceId,
                },
                {
                    headerName: 'Device 1 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[1]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 1 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[1]?.monitorType,
                },
                {
                    headerName: 'Device 1 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[1]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 1 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[1]?.timeout,
                },
                {
                    headerName: 'Device 1 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[1]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 1 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[1]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[1]?.connector,
                },

                // DEVICE 2
                {
                    headerName: 'Device 2 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[2]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 2 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[2]?.deviceId,
                },
                {
                    headerName: 'Device 2 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[2]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 2 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[2]?.monitorType,
                },
                {
                    headerName: 'Device 2 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[2]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 2 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[2]?.timeout,
                },
                {
                    headerName: 'Device 2 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[2]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 2 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[2]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[2]?.connector,
                },

                // DEVICE 3
                {
                    headerName: 'Device 3 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[3]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 3 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[3]?.deviceId,
                },
                {
                    headerName: 'Device 3 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[3]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 3 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[3]?.monitorType,
                },
                {
                    headerName: 'Device 3 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[3]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 3 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[3]?.timeout,
                },
                {
                    headerName: 'Device 3 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[3]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 3 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[3]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[3]?.connector,
                },

                // DEVICE 4
                {
                    headerName: 'Device 4 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[4]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 4 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[4]?.deviceId,
                },
                {
                    headerName: 'Device 4 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[4]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 4 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[4]?.monitorType,
                },
                {
                    headerName: 'Device 4 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[4]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 4 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[4]?.timeout,
                },
                {
                    headerName: 'Device 4 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[4]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 4 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[4]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[4]?.connector,
                },

                // DEVICE 5
                {
                    headerName: 'Device 5 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[5]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 5 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[5]?.deviceId,
                },
                {
                    headerName: 'Device 5 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[5]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 5 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[5]?.monitorType,
                },
                {
                    headerName: 'Device 5 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[5]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 5 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[5]?.timeout,
                },
                {
                    headerName: 'Device 5 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[5]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 5 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[5]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[5]?.connector,
                },

                // DEVICE 6
                {
                    headerName: 'Device 6 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[6]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 6 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[6]?.deviceId,
                },
                {
                    headerName: 'Device 6 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[6]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 6 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[6]?.monitorType,
                },
                {
                    headerName: 'Device 6 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[6]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 6 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[6]?.timeout,
                },
                {
                    headerName: 'Device 6 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[6]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 6 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[6]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[6]?.connector,
                },

                // DEVICE 7
                {
                    headerName: 'Device 7 Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[7]?.deviceId' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 7 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.deviceId != null
                                ? Enums.toString(
                                    Enums_Config.AuxDeviceType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.deviceId
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[7]?.deviceId,
                },
                {
                    headerName: 'Device 7 Monitor Type',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[7]?.monitorType' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 7 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.monitorType != null
                                ? Enums.toString(
                                    Enums_Config.MonitorType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.monitorType
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[7]?.monitorType,
                },
                {
                    headerName: 'Device 7 Monitor Timeout',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[7]?.timeout' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 7 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.timeout != null
                                ? props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.timeout + ' Seconds'
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[7]?.timeout,
                },
                {
                    headerName: 'Device 7 12V Connector',
                    initialHide: true,
                    field: 'configPoll?.auxDeviceWatchdogConfig?.devices[7]?.connector' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.auxDeviceWatchdogConfig?.devices &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices.length > 7 &&
                            props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.connector != null
                                ? Enums.toString(
                                    Enums_Config.Connector12VType,
                                    props.data?.configPoll?.auxDeviceWatchdogConfig?.devices[7]?.connector
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.auxDeviceWatchdogConfig?.devices?.[7]?.connector,
                },
            ]
        },
        {
            headerName: 'Local Dimming',
            children: [
                {
                    headerName: 'Disable Local Dimming',
                    initialHide: true,
                    field: 'configPoll?.localDimConfig?.localDimMode' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.localDimConfig?.localDimMode != null
                                ? Enums.toString(Enums_Config.LocalDimModeType, props.data?.configPoll?.localDimConfig?.localDimMode)
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.localDimConfig?.localDimMode,
                },
                {
                    headerName: 'Local Dim Power Save Level',
                    initialHide: true,
                    field: 'configPoll?.localDimConfig?.powerSaveLevel' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.localDimConfig?.powerSaveLevel != null
                                ? Enums.toString(
                                    Enums_Config.LocalDimPowerSaveLevelType,
                                    props.data?.configPoll?.localDimConfig?.powerSaveLevel
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.localDimConfig?.powerSaveLevel,
                },
            ]
        },
        {
            headerName: 'OSD',
            children: [
                {
                    headerName: 'Vtrim Control Period Msec',
                    initialHide: true,
                    field: 'configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorPeriodSecs' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorPeriodSecs}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.ampVuConfig?.vTrimConfig?.vtrimMonitorPeriodSecs,
                },
                {
                    headerName: 'OSD Refresh Period Msec',
                    initialHide: true,
                    field: 'configPoll?.osdConfig?.refreshMsec' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.osdConfig?.refreshMsec}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.osdConfig?.refreshMsec,
                },
                {
                    headerName: 'OSD Page Switch Msec',
                    initialHide: true,
                    field: 'configPoll?.osdConfig?.pageSwitchMsec' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.osdConfig?.pageSwitchMsec}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.osdConfig?.pageSwitchMsec,
                },
                {
                    headerName: 'OSD Page Mask',
                    initialHide: true,
                    field: 'configPoll?.osdConfig?.pageMask' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.osdConfig?.pageMask}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.osdConfig?.pageMask,
                },
                {
                    headerName: 'OSD Orientation',
                    initialHide: true,
                    field: 'configPoll?.osdConfig?.orientation' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.osdConfig?.orientation != null
                                ? Enums.toString(Enums_Config.OsdOrientationType, props.data?.configPoll?.osdConfig?.orientation)
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.osdConfig?.orientation,
                },
            ]
        },
        {
            headerName: 'Infinite Touch',
            children: [
                {
                    headerName: 'Touch Control',
                    initialHide: true,
                    field: 'configPoll?.videoConfig?.touchControl' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.videoConfig?.touchControl != null
                                ? Enums.toString(Enums_Config.TouchControlType, props.data?.configPoll?.videoConfig?.touchControl)
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.videoConfig?.touchControl,
                },
                {
                    headerName: 'Number of Touchscreens',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.numTouchscreens' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.numTouchscreens}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.numTouchscreens,
                },
                {
                    headerName: 'Touch 1 IP Address',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[0]?.ipAddress' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 0 &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens[0]?.ipAddress}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[0]?.ipAddress,
                },
                {
                    headerName: 'Touch 1 Port',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[0]?.port' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 0 &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens[0]?.port}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[0]?.port,
                },
                {
                    headerName: 'Touch 2 IP Address',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[1]?.ipAddress' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 1 &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens[1]?.ipAddress}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[1]?.ipAddress,
                },
                {
                    headerName: 'Touch 2 Port',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[1]?.port' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 1 &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens[1]?.port}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[1]?.port,
                },
                {
                    headerName: 'Touch 1 TTY USB Dev',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[0]?.sigmaTtyUsbDev' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 0 &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens[0]?.sigmaTtyUsbDev}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[0]?.sigmaTtyUsbDev,
                },
                {
                    headerName: 'Touch 2 TTY USB Dev',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[1]?.sigmaTtyUsbDev' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 1 &&
                                props.data?.configPoll?.sigmaSenseConfig?.touchscreens[1]?.sigmaTtyUsbDev}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[1]?.sigmaTtyUsbDev,
                },
                {
                    headerName: 'Touch Polling Interval',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.sigmaPollInterval' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.sigmaPollInterval}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.sigmaPollInterval,
                },
                {
                    headerName: 'Touch 1 Capture mode',
                    initialHide: true,
                    field: 'configPoll?.sigmaSenseConfig?.touchscreens[0]?.autoCaptureMode' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.sigmaSenseConfig?.touchscreens &&
                            props.data?.configPoll?.sigmaSenseConfig?.touchscreens.length > 0 &&
                            props.data?.configPoll?.sigmaSenseConfig?.touchscreens[0]?.autoCaptureMode != null
                                ? Enums.toString(
                                    Enums_Config.InfiniteTouchAutoCaptureModeType,
                                    props.data?.configPoll?.sigmaSenseConfig?.touchscreens[0]?.autoCaptureMode
                                )
                                : '-'}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.sigmaSenseConfig?.touchscreens?.[0]?.autoCaptureMode,
                },
            ]
        },
        {
            headerName: 'License',
            children: [
                {
                    headerName: 'License Key',
                    initialHide: true,
                    field: 'configPoll?.licenseVuConfig?.licenseKey' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.licenseVuConfig?.licenseKey}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.licenseVuConfig?.licenseKey,
                },
                {
                    headerName: 'Weather Service License Key',
                    initialHide: true,
                    field: 'configPoll?.weatherVuConfig?.weatherKey' as any,
                    cellRenderer: (props: IDisplayFieldProps) => (
                        <div>
                            {props.data?.configPoll?.weatherVuConfig?.weatherKey}
                        </div>
                    ),
                    valueGetter: (props) => props.data?.configPoll?.weatherVuConfig?.weatherKey,
                },
            ]
        },
    ];
}

function getDoorSensorConnector(sensors: Mri.Config.DoorSensor[], doorSensorType: number) {
    const sensor = sensors.find(s => s.doorSensorType == doorSensorType);

    if (sensor && sensor.connector) return sensor.connector;
    else return '-';
}

function getDoorSensorEnabled(sensors: Mri.Config.DoorSensor[], doorSensorType: number) {
    const sensor = sensors.find(s => s.doorSensorType == doorSensorType);

    if (sensor && sensor.enabled) return 'True';
    if (sensor && !sensor.enabled) return 'False';
    else return '-';
}
